import './lib/jquery'

document.addEventListener('DOMContentLoaded', () => {
  /* eslint-disable-next-line */
  $('.header').click(function () {
    $(this).find('span').text((_, value) => (value === '-' ? '+' : '-'))
    $(this).nextUntil('tr.header').slideToggle(100, () => {})
  })
})
